import { mapEntityProperties } from '@/utils/mapEntityProperties'
import type { CompanySubscriptionListedAdminDto } from '@/backend/market'
import { CompaniesSubscriptionEntity } from '../../domain/entities/CompaniesSubscriptionEntity'

export class CompaniesSubscriptionModel extends CompaniesSubscriptionEntity {
  constructor(dataDto: CompanySubscriptionListedAdminDto) {
    super()
    mapEntityProperties<CompaniesSubscriptionEntity>(this, dataDto)
  }
}
